import styled from 'styled-components';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 0 0;
  gap: 24px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
